import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import User from "api/types/models/user";

export interface AuthState {
  email: string | null | undefined;
  authenticated: boolean;
  user: User | null;
  change_password_step: number;
}

const initialState: AuthState = {
  email: undefined,
  authenticated: false,
  user: null,
  change_password_step: 1,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setEmail: (state, email: PayloadAction<string>) => {
      state.email = email.payload;
    },
    login: (state, user: PayloadAction<User>) => {
      state.authenticated = true;
      state.user = user.payload;
    },
    logout: (state) => {
      if (state.authenticated) {
        window.location.reload();
      }
    },
    clearAuth: (state) => {
      state.email = null;
      state.authenticated = false;
      state.user = null;
      state.change_password_step = 1;
    },
    nextChangePasswordStep: (state) => {
      state.change_password_step++;
    },
    previousChangePasswordStep: (state) => {
      state.change_password_step--;
    },
    clearChangePasswordStep: (state) => {
      state.change_password_step = initialState.change_password_step;
    },
  },
});

export const {
  setEmail,
  login,
  logout,
  clearAuth,
  nextChangePasswordStep,
  clearChangePasswordStep,
  previousChangePasswordStep,
} = authSlice.actions;

export default authSlice.reducer;
